import React, { Component } from 'react'; // eslint-disable-line no-unused-vars
import {Modal, Card, Button} from 'antd';
import {Link} from 'react-router-dom';
function PoetBio(props){

  function renderBio(){
    if(!Array.isArray(props.poet.longBio))
      return null

    return props.poet.longBio.map((obj, key) => {
      let payload = null;
      if(obj.type === "paragraph"){
        payload = <p key={key}>{obj.text}</p>;
      } else if (obj.type === "blockQuote") {
        payload = <blockquote key={key}>{obj.text} <cite>{obj.source}</cite></blockquote>;
      }

      return payload;
    });
  }

  function handleLink(e){
    // if(!props.home.user){
    //   e.preventDefault();
    //   Modal.error({
    //     title: 'You are not signed in!',
    //     content: 'You must sign-in or create an account to access courses',
    //   });
    // }
  }

  function renderPoems(){
    return props.poet.poems.map(poem => {
      return <li key={poem.poemID}>
        <Link onClick={handleLink} to={'/' + props.poet.poetID + '/' + poem.poemID + "/lesson/1"}>
          <Button className="poet-poem">{poem.title}</Button>
        </Link>
      </li>
    }
    );
  }

  function renderStart(){
    if(props.poet.poems[0])
      return (
        <Link onClick={handleLink} to={'/' + props.poet.poetID + '/' + props.poet.poems[0].poemID + "/lesson/1"}>
          <Button type="primary" id="poet-bio-start">Start</Button>
        </Link>
      )
  }

  return (
    <div id="PoetBio">
      <div id="poet-sidebar">
        <h1>{props.poet.name}</h1>
        <img id="poet-image" alt={props.poet.name} src={require('../../images/poets/' + props.poet.poetID  +'.png')} />
        {renderStart()}
        <Card id="poet-poems-list" hoverable={true}>
        <h2 style={{marginTop: '-5px', textAlign: 'center'}}>Poems</h2>
          <ul>
          <li key="tutorial">
            <Link onClick={handleLink} to={"/closereading/tutorial/lesson/1"}>
              <Button className="poet-poem">Tutorial</Button>
            </Link>
          </li>
            {renderPoems()}
          </ul>
        </Card>
      </div>
      <Card id="poet-bio-text" hoverable={true} title="Biography and Introduction">
        {renderBio()}
      </Card>
    </div>
  )
}

export default PoetBio;



// WEBPACK FOOTER //
// ./src/components/Poet/PoetBio.js